// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import { registerNiiwinControllers } from "@niiwin/core";

// Import and register all Niiwin Stimulus controllers (first)
registerNiiwinControllers(application);

import AdminEditUserModalController from "./admin_edit_user_modal_controller";
application.register("admin-edit-user-modal", AdminEditUserModalController);

import BackButtonController from "./back_button_controller";
application.register("back-button", BackButtonController);

import BundleOrganizeController from "./bundle_organize_controller";
application.register("bundle-organize", BundleOrganizeController);

import BundleRevertConfirmController from "./bundle_revert_confirm_controller";
application.register("bundle-revert-confirm", BundleRevertConfirmController);

import DatagridController from "./datagrid_controller";
application.register("datagrid", DatagridController); // Overridden

import FileInputController from "./file_input_controller";
application.register("file-input", FileInputController);

import FontSizeController from "./font_size_controller";
application.register("font-size", FontSizeController);

import FormController from "./form_controller";
application.register("form", FormController);

import ImageGalleryController from "./image_gallery_controller";
application.register("image-gallery", ImageGalleryController);

import MfaAdminLockCountdownController from "./mfa_admin_lock_countdown_controller";
application.register("mfa-admin-lock-countdown", MfaAdminLockCountdownController);

import MfaAdminLockController from "./mfa_admin_lock_controller";
application.register("mfa-admin-lock", MfaAdminLockController);

import MfaAdminRecoveryController from "./mfa_admin_recovery_controller";
application.register("mfa-admin-recovery", MfaAdminRecoveryController);

import MfaCountdownController from "./mfa_countdown_controller";
application.register("mfa-countdown", MfaCountdownController);

import MfaOtpInputController from "./mfa_otp_input_controller";
application.register("mfa-otp-input", MfaOtpInputController);

import PaginationController from "./pagination_controller";
application.register("pagination", PaginationController);

import RadioAdditionalFieldController from "./radio_additional_field_controller";
application.register("radio-additional-field", RadioAdditionalFieldController);

import RedirectController from "./redirect_controller";
application.register("redirect", RedirectController);

import SafeSpaceController from "./safe_space_controller";
application.register("safe-space", SafeSpaceController);

import SearchSelectController from "./search_select_controller";
application.register("search-select", SearchSelectController);

import SelectAdditionalFieldController from "./select_additional_field_controller";
application.register("select-additional-field", SelectAdditionalFieldController);

import SelectController from "./select_controller";
application.register("select", SelectController); // Overridden

import StackedModalController from "./stacked_modal_controller";
application.register("stacked-modal", StackedModalController); // Overridden

import TagController from "./tag_controller";
application.register("tag", TagController);

import UserApprovalStatusMessageController from "./user_approval_status_message_controller";
application.register("user-approval-status-message", UserApprovalStatusMessageController);
